import React, { useEffect, useState } from "react";
import Sidebar from "../../Common/Sidebar";
import EmployerLayout from "./Common/EmployerLayout";
import { useDispatch } from "react-redux";
import { GetMyPostedJobs, getAllJobs } from "../../../Redux/Slices/JobPost";
import { GetUserSubscriptions } from "../../../Redux/Slices/Package";
import EmployerSubscriptions from "./EmployerSubscriptions";
import NoSubscriptionAlert from "./NoSubscriptionAlert";
import { useNavigate } from "react-router-dom";
import { formatDate } from "../../../Helper/FromatTime";
import { FaEye, FaUsers, FaBriefcase, FaCheckCircle, FaTimesCircle } from "react-icons/fa";
import "../../../asset/new/css/employer-modern.css";

const EmployerDashboard = () => {
  const [allJobs, setAllJobs] = useState(null);
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const [salesHistory, setSalesHistory] = useState(null);

  const salesHistoryHandler = async () => {
    let data = await GetUserSubscriptions();
    setSalesHistory(data?.subscriptions);
  };

  //----------  Dashboard Count Number --------------

  const postedJobs = allJobs?.docs?.filter((item) => item)?.length;

  const approvedJobs = allJobs?.docs?.filter(
    (item) => item?.admin_approval === "approved"
  );

  const activeJobs = allJobs?.docs?.filter(
    (item) => item?.admin_approval === "approved" && item?.is_active === true
  )?.length;

  const rejectedJobs = allJobs?.docs?.filter(
    (item) => item?.admin_approval === "rejected" || item?.is_active === false
  )?.length;

  // ------------ Views -----------
  const getTotalViews = (jobsData) => {
    let totalViews = 0;

    jobsData?.forEach((job) => {
      totalViews += job?.views || 0;
    });

    return totalViews;
  };
  //---------- Total Applicants ---------
  const getTotalUsers = (jobsData) => {
    const uniqueUsers = new Set();

    jobsData?.forEach((job) => {
      job.applications?.forEach((application) => {
        uniqueUsers?.add(application?._id);
      });
    });

    return uniqueUsers?.size;
  };

  /// Get the total number of views on post
  const totalViews = getTotalViews(allJobs?.docs);

  const myjobhnadler = async () => {
    let data = await GetMyPostedJobs();
    setAllJobs(data);
  };

  useEffect(() => {
    myjobhnadler();
    dispatch(getAllJobs());
    salesHistoryHandler();
    document.title = "Dashboard | CAJobPortal";
  }, []);

  return (
    <div className="employer-layout">
      <Sidebar />
      <EmployerLayout breadcrumbs={['Employer', 'Dashboard']}>
        {/* Page Header */}
        <div className="employer-page-header">
          <h1 className="employer-page-title">Dashboard</h1>
        </div>

        {/* Alert */}
        <NoSubscriptionAlert salesHistory={salesHistory} />

        {/* Stats Grid */}
        <div className="employer-stats-grid">
          <div className="employer-stat-card">
            <div className="employer-stat-icon primary">
              <FaEye />
            </div>
            <div className="employer-stat-content">
              <div className="employer-stat-label">Total Views</div>
              <div className="employer-stat-value">{totalViews || 0}</div>
            </div>
          </div>

          <div className="employer-stat-card">
            <div className="employer-stat-icon success">
              <FaUsers />
            </div>
            <div className="employer-stat-content">
              <div className="employer-stat-label">Applications</div>
              <div className="employer-stat-value">{getTotalUsers(allJobs?.docs) || 0}</div>
            </div>
          </div>

          <div className="employer-stat-card">
            <div className="employer-stat-icon primary">
              <FaBriefcase />
            </div>
            <div className="employer-stat-content">
              <div className="employer-stat-label">Jobs Posted</div>
              <div className="employer-stat-value">{postedJobs || 0}</div>
            </div>
          </div>

          <div className="employer-stat-card">
            <div className="employer-stat-icon success">
              <FaCheckCircle />
            </div>
            <div className="employer-stat-content">
              <div className="employer-stat-label">Active Jobs</div>
              <div className="employer-stat-value">{activeJobs || 0}</div>
            </div>
          </div>

          <div className="employer-stat-card">
            <div className="employer-stat-icon danger">
              <FaTimesCircle />
            </div>
            <div className="employer-stat-content">
              <div className="employer-stat-label">Inactive Jobs</div>
              <div className="employer-stat-value">{rejectedJobs || 0}</div>
            </div>
          </div>
        </div>

        {/* Pending Jobs Table */}
        {approvedJobs?.length > 0 && (
          <div className="employer-card employer-mb-4">
            <div className="employer-card-header">
              <h3 className="employer-card-title">Pending Jobs</h3>
            </div>
            <div className="employer-table-container">
              <table className="employer-table">
                <thead>
                  <tr>
                    <th>Job ID</th>
                    <th>Job Title</th>
                    <th>Posted By</th>
                    <th>Posted Date</th>
                    <th>Industry</th>
                    <th>Action</th>
                  </tr>
                </thead>
                <tbody>
                  {approvedJobs?.length !== 0 ? (
                    approvedJobs?.map((value, index) => (
                      <tr key={index}>
                        <td>{index + 1}</td>
                        <td>{value?.title}</td>
                        <td>{value?.created_by?.name || "N/A"}</td>
                        <td>{formatDate(value?.posted_date)}</td>
                        <td>{value?.industry?.name || "N/A"}</td>
                        <td>
                          <button
                            onClick={() =>
                              navigate(`/employer/reviewJob/${value?._id}`)
                            }
                            className="employer-btn employer-btn-primary employer-btn-sm"
                          >
                            View Details
                          </button>
                        </td>
                      </tr>
                    ))
                  ) : (
                    <tr>
                      <td colSpan="6" className="employer-table-empty">
                        No Data Available In Table
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>
          </div>
        )}

        {/* Subscription */}
        {salesHistory && <EmployerSubscriptions salesHistory={salesHistory} />}
      </EmployerLayout>
    </div>
  );
};

export default EmployerDashboard;
